export const checked= <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0,0,256,256">
<g fill="#72d30a" fillRule="nonzero" stroke="none" strokeWidth="1" strokeLinecap="butt" strokeLinejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none" font-weight="none" font-size="none" text-anchor="none" ><g transform="scale(10.66667,10.66667)"><path d="M20.29297,5.29297l-11.29297,11.29297l-4.29297,-4.29297l-1.41406,1.41406l5.70703,5.70703l12.70703,-12.70703z"></path></g></g>
</svg>
export const pencil = <svg xmlns="http://www.w3.org/2000/svg" height="16px" viewBox="0 -960 960 960" width="16px" fill="#5f6368"><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>

export const shippingBus= <svg
width="70"
height="30"
viewBox="0 0 27 12"
fill="none"
xmlns="http://www.w3.org/2000/svg"
>
<g clipPath="url(#clip0_12_99)">
  <path
    d="M20.8312 10.2108H6.83187C6.70529 10.2108 6.59961 10.1036 6.59961 9.97246V0.344336C6.59961 0.212036 6.70529 0.105957 6.83187 0.105957H20.8312C20.9578 0.105957 21.0623 0.212036 21.0623 0.344336V9.97246C21.0623 10.1036 20.9578 10.2108 20.8312 10.2108ZM7.06413 9.73409H20.5966V0.582715H7.06413V9.73409Z"
    fill="#3A5755"
  />
  <path
    d="M26.7213 10.219H20.8742C20.8115 10.219 20.7523 10.194 20.7081 10.1475C20.664 10.1022 20.6396 10.0391 20.6419 9.97471C20.7012 7.32512 20.7604 3.03668 20.6791 2.45266C20.671 2.44074 20.664 2.42643 20.657 2.41332C20.6222 2.32393 20.6431 2.22143 20.707 2.15349C20.7615 2.09866 20.8382 2.07482 20.9114 2.08317H23.2723C23.3605 2.08317 23.4406 2.13442 23.4801 2.21547L24.7564 4.83049L26.8223 5.86982C26.9013 5.90915 26.9524 5.99258 26.9524 6.08436V9.98186C26.9535 10.113 26.8479 10.219 26.7213 10.219ZM21.1123 9.74229H26.489V6.23216L24.48 5.22381C24.4359 5.19997 24.3987 5.16303 24.3755 5.11654L23.1294 2.56112H21.139C21.2063 3.24646 21.2156 5.02 21.1123 9.74229Z"
    fill="#3A5755"
  />
  <path
    d="M12.9101 10.0502C12.9101 10.9286 12.2156 11.6413 11.3597 11.6413C10.5039 11.6413 9.80942 10.9274 9.80942 10.0502C9.80942 9.17174 10.5039 8.45898 11.3597 8.45898C12.2156 8.45898 12.9101 9.17055 12.9101 10.0502Z"
    fill="white"
  />
  <path
    d="M11.3597 11.8793C10.3761 11.8793 9.57832 11.0581 9.57832 10.0498C9.57832 9.04024 10.3773 8.22021 11.3597 8.22021C12.3422 8.22021 13.1423 9.04024 13.1423 10.0498C13.1423 11.0581 12.3434 11.8793 11.3597 11.8793ZM11.3597 8.69697C10.6328 8.69697 10.0417 9.30365 10.0417 10.0498C10.0417 10.7959 10.6328 11.4026 11.3597 11.4026C12.0867 11.4026 12.679 10.7959 12.679 10.0498C12.679 9.30365 12.0867 8.69697 11.3597 8.69697Z"
    fill="#3A5755"
  />
  <path
    d="M25.3475 10.0966C25.3475 10.975 24.653 11.6877 23.7972 11.6877C22.9401 11.6877 22.2468 10.975 22.2468 10.0966C22.2468 9.21812 22.9401 8.50537 23.7972 8.50537C24.653 8.50537 25.3475 9.21812 25.3475 10.0966Z"
    fill="white"
  />
  <path
    d="M23.7972 11.9274C22.8124 11.9274 22.0146 11.105 22.0146 10.0966C22.0146 9.08711 22.8136 8.26709 23.7972 8.26709C24.7808 8.26709 25.5797 9.08711 25.5797 10.0966C25.5797 11.105 24.7819 11.9274 23.7972 11.9274ZM23.7972 8.74385C23.0702 8.74385 22.4791 9.35052 22.4791 10.0966C22.4791 10.8428 23.0702 11.4506 23.7972 11.4506C24.5241 11.4506 25.1152 10.8428 25.1152 10.0966C25.1152 9.35052 24.5241 8.74385 23.7972 8.74385Z"
    fill="#3A5755"
  />
  <path
    d="M11.0253 3.23213H3.8102C3.68362 3.23213 3.57794 3.12486 3.57794 2.99375C3.57794 2.86145 3.68362 2.75537 3.8102 2.75537H11.0253C11.153 2.75537 11.2576 2.86145 11.2576 2.99375C11.2576 3.12486 11.153 3.23213 11.0253 3.23213Z"
    fill="#3A5755"
  />
  <path
    d="M11.0834 5.14277H0.232258C0.104516 5.14277 0 5.0355 0 4.90439C0 4.77209 0.104516 4.66602 0.232258 4.66602H11.0834C11.2111 4.66602 11.3156 4.77209 11.3156 4.90439C11.3156 5.03669 11.2111 5.14277 11.0834 5.14277Z"
    fill="#3A5755"
  />
  <path
    d="M11.0253 7.11445H5.22116C5.09458 7.11445 4.99007 7.00718 4.99007 6.87607C4.99007 6.74377 5.09458 6.6377 5.22116 6.6377H11.0253C11.153 6.6377 11.2576 6.74377 11.2576 6.87607C11.2576 7.00718 11.153 7.11445 11.0253 7.11445Z"
    fill="#3A5755"
  />
</g>
<defs>
  <clipPath id="clip0_12_99">
    <rect width="27" height="12" fill="white" />
  </clipPath>
</defs>
</svg>
export const checkIcon =  <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#18333C"><path d="M379.33-244 154-469.33 201.67-517l177.66 177.67 378.34-378.34L805.33-670l-426 426Z"/></svg>